
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[...threadOrCategoryParams]",
      function () {
        return require("private-next-pages/forum/[...threadOrCategoryParams].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/[...threadOrCategoryParams]"])
      });
    }
  